<template>
  <a-card class="mb-3">
    <template slot="title">
      <b class="mr-3">需回避专家</b>
      <a-button type="primary" icon="plus-circle" @click="onAddAvoidExpert" ghost>新增
      </a-button>
    </template>

    <a-form-model ref="avoidExpertFormRef" :model="avoidExpertForm" class="exi_form item_100"
                  :label-col="{ flex: '0 0 auto' }" :wrapper-col="{ span: 24 }">
      <!--新增专家-->
      <div class="model-expert" v-if="avoidExpertForm.data.length>0">
        <a-row v-for="(item,index) in avoidExpertForm.data" :gutter="20" type="flex" align="middle">
          <a-col :span="7">
            <a-form-model-item label="专家名称"
                               :rules="{required: true,  whitespace: true, message: '请选择专家名称', trigger: 'change'}"
                               :prop="'data.'+index+'.expertName'">
              <a-select
                  stlye="width: 100%"
                  show-search
                  v-model="item.expertName"
                  placeholder="可输入查询"
                  :default-active-first-option="false"
                  :show-arrow="false"
                  :filter-option="false"
                  :not-found-content="null"
                  @search="handleSearch"
                  @change="handleChange($event,item)"
              >
                <a-select-option v-for="info in expertInfo" :key="info.name">
                  {{ info.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>


            <!--                        <a-form-model-item label="专家名称"-->
            <!--                                           :rules="{required: true,  whitespace: true, message: '请选择专家名称', trigger: 'change'}"-->
            <!--                                           :prop="'data.'+index+'.expertName'">-->
            <!--                            <a-input placeholder="专家名称"-->
            <!--                                     v-model.trim="item.expertName"/>-->
            <!--                        </a-form-model-item>-->
          </a-col>
          <a-col :span="7">
            <a-form-model-item label="专家身份证"
                               :rules="{required: true, whitespace: true, message: '请选择专家身份证', trigger: 'change'}"
                               :prop="'data.'+index+'.idCard'">
              <a-input placeholder="专家身份证"
                       v-model.trim="item.idCard"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="7">
            <a-button @click="delAvoidExpert(item.id)"
                      type="danger" ghost>
              移除
            </a-button>
          </a-col>
        </a-row>
      </div>
      <div v-else>
        暂无数据，点击新增回避专家
      </div>
    </a-form-model>

  </a-card>

</template>
<script>
import { PageView } from '@/layouts'
import { Empty } from 'ant-design-vue'
import { GetAllExpertInfoList } from '@/epp/expertmain/expertInfo/utils/ExpertInfoUtil'

const uuidv4 = require('uuid/v4')

export default {
  name: 'AvoidExpertForm',
  beforeCreate () {
    this.simpleImage = Empty.PRESENTED_IMAGE_SIMPLE
  },
  props: {
    avoidExpertForm: {
      type: Object,
      default () {
        return {
          data: [],
        }
      }
    }
  },
  components: {
    PageView,
  },
  data () {
    return {
      expertInfo: []
    }
  },
  computed: {},
  created () {
  },
  methods: {
    onAddAvoidExpert () {
      const data = {
        id: uuidv4(),
        applyId: this.applyId,
        expertName: '',
        idCard: '',
        expertType: '3'
      }
      this.avoidExpertForm.data.push(data)
    },
    delAvoidExpert (id) {
      const newData = this.avoidExpertForm.data.filter(item => item.id !== id)
      this.avoidExpertForm.data = [...newData]
    },

    async handleSearch (value) {
      if (!value) {
        return
      }
      this.expertInfo = await GetAllExpertInfoList(value)
    },
    handleChange (value, item) {
      let info = this.expertInfo.filter(item2 => item2.name === value)[0]
      if (info) {
        item.idCard = info.idCard
      }
    },
  }
}

</script>

<style scoped lang="less">

</style>
